import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import Item from "./Item";
import {
  getLocalPhoneNumber,
  getFullName,
} from "../../../components/util/helpers";
import { useRelativeTypes } from "../../../hooks";
const { Title } = Typography;

const PatientDetails = (props) => {
  const { startOfTrom } = props;
  const intl = useIntl();
  const relative_types = useRelativeTypes();
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const [type, setType] = useState(null);

  useEffect(() => {
    if (activePatient.relatives.length > 0) {
      const selected = relative_types.filter(
        (item) => item.id === activePatient.relatives[0]["relative_type_id"]
      )[0];
      if (selected) {
        setType(selected["name"]);
      }
    }
  }, [relative_types, activePatient]);

  const getAddress = () => {
    const address = activePatient.address || {};
    const street = address.street
      ? `${address.street} ${address.house_number || ""}`.trim()
      : "";
    const city = address.city || "";
    return city ? `${city}${street ? ", " + street : ""}` : street;
  };

  const address = getAddress();

  const getLocalId = () => {
    return activePatient.local_id_number.padStart(9, "0");
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="section" style={{ width: "100%" }}>
        <Title level={5}>
          {intl.formatMessage({
            id: "app.orders.patient_details",
          })}
        </Title>
        <div className="rowContainer">
          <Item
            name="full_name"
            content={getFullName(
              activePatient.surename,
              activePatient.first_name
            )}
            line_type="vertical"
          />
          <div className="horizontal_spacer" />
          <Item
            name="local_id_number"
            content={getLocalId()}
            line_type="vertical"
          />
          <div className="horizontal_spacer" />
          <Item name="address" content={address} line_type="vertical" />
          <div className="horizontal_spacer" />
          <Item
            name="phone"
            content={getLocalPhoneNumber(
              activePatient.contact_info.phone_number
            )}
            extraContent={
              activePatient?.contact_info?.mobile_number &&
              getLocalPhoneNumber(activePatient.contact_info.mobile_number)
            }
            line_type="vertical"
          />
        </div>
      </div>
      {startOfTrom ? <div className="verticalSeperator" /> : null}
      {activePatient.relatives.length > 0 && startOfTrom ? (
        <div className="section" style={{ width: "100%" }}>
          <Title level={5}>
            {intl.formatMessage({
              id: "app.orders.relative",
            })}
          </Title>
          <div className="rowContainer">
            <Item
              name="full_name"
              content={
                activePatient.relatives[0]["first_name"] +
                " " +
                activePatient.relatives[0]["last_name"]
              }
              line_type="vertical"
            />
            <div className="horizontal_spacer" />
            <Item name="relative_type" content={type} line_type="vertical" />
            <div className="horizontal_spacer" />
            <Item
              name="phone"
              content={getLocalPhoneNumber(
                activePatient.relatives[0]["phone_number"]
              )}
              line_type="vertical"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PatientDetails;
